import { BoxErrorItem } from '@/box/interface'
import { getFormatMessage } from '@/utils/utils'
import { message } from 'antd'

export enum BoxErrorCode {
  ConnectError = 10001003, // 连接失败
  VersionError = 10001005, // 版本号错误
  FloaderError = 10001008, // floader错误
  ModeError = 10001009 // 模式错误
}

const specifyErrors = [
  9000,
  9001,
  9002,
  BoxErrorCode.ConnectError,
  BoxErrorCode.VersionError,
  BoxErrorCode.FloaderError,
  BoxErrorCode.ModeError
]

export default function onBrokerErrorHandle(
  err: any,
  boxErrorHandler: (error: BoxErrorItem) => void
) {
  const formatMessage = getFormatMessage()
  if (err.code !== undefined && err.code !== 0) {
    let errors: BoxErrorItem[] = []
    if (err.data) {
      // 返回是数组
      if (Array.isArray(err.data)) {
        errors = err.data.map((x) => ({
          code: err.code,
          boxNo: x?.boxNo,
          msg: `${formatMessage({
            id: 'app.device.code.' + err.code,
            parameters: x
          })}(code: ${err.code})`
        }))
      } else {
        // 返回是对象
        errors = [
          {
            code: err.code,
            msg: `${formatMessage({
              id: 'app.device.code.' + err.code,
              parameters: err.data
            })}(code: ${err.code})`
          }
        ]
      }
    } else {
      errors = [
        {
          code: err.code,
          msg: `${formatMessage({
            id: 'app.device.code.' + err.code
          })}(code: ${err.code})`
        }
      ]
    }

    for (const err of errors) {
      if (specifyErrors.includes(err.code)) {
        boxErrorHandler(err)
      } else {
        message.error(err.msg)
      }
    }
  } else {
    message.error(formatMessage({ id: 'app.device.code.unknown' }))
  }
}
